"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var cookies_1 = require("../../shared/utils/cookies");
var NextAdapter_1 = require("../../shared/adapters/NextAdapter");
var initSupabase_1 = require("../utils/initSupabase");
var constants_1 = require("../../shared/utils/constants");
function handleLogout(req, res, options) {
    var _a;
    if (options === void 0) { options = {}; }
    var returnTo = req.query.returnTo;
    if (!returnTo)
        returnTo = (_a = options === null || options === void 0 ? void 0 : options.returnTo) !== null && _a !== void 0 ? _a : '/';
    returnTo = Array.isArray(returnTo) ? returnTo[0] : returnTo;
    returnTo = returnTo.charAt(0) === '/' ? returnTo : "/" + returnTo;
    var cookieOptions = tslib_1.__assign(tslib_1.__assign({}, constants_1.COOKIE_OPTIONS), options.cookieOptions);
    // Logout request to Gotrue
    var access_token = req.cookies[cookieOptions.name + "-access-token"];
    if (access_token)
        initSupabase_1.supabaseClient.auth.api.signOut(access_token);
    // Delete cookies
    cookies_1.setCookies(new NextAdapter_1.NextRequestAdapter(req), new NextAdapter_1.NextResponseAdapter(res), ['access-token', 'refresh-token', 'provider-token'].map(function (key) { return ({
        name: cookieOptions.name + "-" + key,
        value: '',
        maxAge: -1
    }); }));
    res.redirect(returnTo);
}
exports.default = handleLogout;
//# sourceMappingURL=logout.js.map